import { createBrowserHistory } from 'history';

export const historyRefresh = createBrowserHistory({ forceRefresh: true });
export const history = createBrowserHistory();